import { authorizedGet, authorizedPost, authorizedPut, authorizedDelete } from "./AuthService";
import { useState } from "react";

export const AccessReqHandler = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [requests, setRequests] = useState([]);
    const [users, setUsers] = useState([]);
    const [isUsersLoading, setIsUsersLoading] = useState(true);

    const formatUser = (user, roleNameMap) => {
        const department = user.department || "";
        const roleKeys = department.split(',').map(d => d.trim()).filter(Boolean); 
        //Get the role name from the value of the map (e.g. produccion → Operador)
        const roleName = roleKeys.map(key => roleNameMap[key] || key).join(', ');

        return {...user, department, roleName, roleKeys}
    }

    const getRequests = async () => {
        try {
            const response = await authorizedGet("/accessreq/getAll")
            const resData = await response.body.json();
            setRequests(resData);
            // console.log("Requests: ", resData);
        } catch(e) {
            console.log("Error al listar las solicitudes de acceso: ", e);

        } finally {
            setIsLoading(false);
        }
    }

    const createUser = async (userData) => {
        try {
            const response = await authorizedPost("/admin/createUser", userData)
            const resData = await response.body.json();
            // console.log("Create user: ", resData);

            return {success: true}
        } catch(e) {
            console.error("Error al crear el usuario: ", e);
            return {success: false}
        }
    }

    const getUsers = async (roleNameMap) => {
        try {
            setIsUsersLoading(true)
            const response = await authorizedGet("/admin/getUsers")
            const resData = await response.body.json()
            // console.log("List users: ", resData);
            const formattedUsers = resData.map(u => formatUser(u, roleNameMap || {}));
            setUsers(formattedUsers);
        } catch(e) {
            console.log("Error al listar los usuarios: ", e);

        } finally {
            setIsUsersLoading(false);
        }
    }

    const updateUser = async (data) => {
        try {
            const response = await authorizedPut("/admin/updateUser", data)
            const resData = await response.body.json()
            // console.log("Update user: ", resData);
            return {success: true}
        } catch(e) {
            console.error("Error al actualizar el usuario: ", e);
            return {success: false}
        }
    }

    const updateRequest = async (data) => {
        try {
            const response = await authorizedPut("/accessreq/update", data)
            const resData = await response.body.json()
            // console.log("Update user: ", resData)
            getRequests();  //Update the requests
            return {success: true}
        } catch(e) {
            console.error("Error al actualizar la solicitud de acceso: ", e);
            return {success:false}
        }
    }

    const validateToken = async (token, deleteToken=false) => {
        try {
            const response = await authorizedGet(`/accessreq/validateToken?token=${token}${deleteToken ? '&delete=true' : ''}`);
            const resData = await response.body.json()
            // console.log("Token data: ", resData);
            return resData;
        } catch(e) {
            console.error("Error al validar el token: ", e);
            return null;
        }
    }

    const deleteUser = async (user) => {
        try {
            const response = await authorizedDelete("/admin/deleteUser", {mail: user})
            const resData = await response.body.json()
            // console.log("Delete response: ", resData);
            return {success: true}
        } catch(e) {
            console.log("Error al eliminar al usuario: ", e);
        }
    }

    return {requests, isLoading, users, isUsersLoading, getRequests, createUser, getUsers, updateUser, updateRequest, validateToken, deleteUser}
}

